import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    // Desktop styles
    flyingCartDesktopButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(1, 3),
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: theme.shadows[2],
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark,
        },
    },

    // Mobile styles
    flyingCartMobileButton: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        padding: theme.spacing(1, 2),
        textTransform: "none",
        minWidth: "120px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
            boxShadow: "none",
        },
        "&:active": {
            backgroundColor: theme.palette.background.main,
            boxShadow: "none",
        },
    },
}));
